export const initial = {
  currentPage: 1,
  itemsPerPage: 10,
  items: [],
  count: 0,
  names: [],
  sort: {
    key: 'createDate',
    order: -1,
  },
  filter: {
    id: '',
    publisherId: '',
    publisherName: '',
    publisherEmail: '',
    name: '',
    category: '',
    os: '',
    status: '',
    isLive: '',
  },
};



/** WEBPACK FOOTER **
 ** ./js/redux/state/apps.state.js
 **/